import { render, staticRenderFns } from "./UrunDetail.vue?vue&type=template&id=257e1066&"
import script from "./UrunDetail.vue?vue&type=script&lang=js&"
export * from "./UrunDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports